export default __webpack_public_path__ + "static/media/paper-plane.ee9b5c8a.svg";